import { Plan } from 'AppTypes';
import { Card } from './card';
import clsx from 'clsx';
import { calculatePrice } from '../utils/calculatePrice';
// usestate
import { useState } from 'react';

const activeClasses =
	'border border-primary-purplish-blue bg-neutral-magnolia falopa';

const plans: Plan[] = [
	{
		name: 'Arcade',
		icon: 'icon-arcade.svg',
		monthlyPrice: 9,
	},
	{
		name: 'Advanced',
		icon: 'icon-advanced.svg',
		monthlyPrice: 12,
	},

];

interface SelectPlanProps {
	selectedPlan: Plan | null;
	monthly: boolean;
	updateSelectedPlan: (selectedPlan: Plan) => void;
	updateIsMonthly: (isMonthly: boolean) => void;
}

export const SelectPlan = ({
	selectedPlan,
	monthly,
	updateSelectedPlan,
	updateIsMonthly,
}: SelectPlanProps) => {

  const [formhidden,setFormHidden]=useState('none')

	return (
		<section className="flex flex-col gap-4 w-full">
			<h2>Characteristics of your own battery</h2>

      <div>
  <label  className="block text-xs font-medium text-gray-700">
    Name of your battery
  </label>

  <input
    type="text"
    id="batteryname"
    placeholder="My battery"
    className="mt-1 w-full rounded-md border-gray-200 shadow-sm sm:text-sm"
  />
</div>
			<div className="bg-neutral-alabaster w-full rounded-sm felx p-4  ">
				<label className="flex relative items-center cursor-pointer mx-auto w-min">
					<span
						className={clsx(
							`mr-4 font-medium`,
							monthly ? 'text-primary-marine-blue' : ''
						)}
					>
						Default
					</span>
					<input
						type="checkbox"
						/*
            onChange={
              () => {
                updateIsMonthly(!monthly);
                setFormHidden(
                  formhidden === 'none' ? 'block' : 'none'
                )
              }
            }
            */
						className="sr-only peer"
					/>
					<div className="w-11 h-6 peer-focus:outline-none rounded-full peer bg-primary-marine-blue peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[80px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
					<span
						className={clsx(
							`ml-4 font-medium`,
							!monthly ? 'text-primary-marine-blue' : ''
						)}
					>
						Customise
					</span>
				</label>
			</div>
      <form action="" className="space-y-4" style={{ display: formhidden }}>




<div className="grid grid-cols-1 gap-4 text-center sm:grid-cols-3">
<div>
<label > Lithium (Li) </label>

<div className="flex items-center gap-1" style={{justifyContent:"center"}}>
<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>
&minus;
</button>

<input
type="number"
id="Quantity"
defaultValue={1}

className="h-10 w-16 rounded border-gray-200 text-center [-moz-appearance:_textfield] sm:text-sm [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none"
/>

<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>+
</button>
</div>

</div>
<div>
<label  > Oxygen (O) </label>

<div className="flex items-center gap-1" style={{justifyContent:"center"}}>
<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>
&minus;
</button>

<input
type="number"
id="Quantity"
defaultValue={1}
className="h-10 w-16 rounded border-gray-200 text-center [-moz-appearance:_textfield] sm:text-sm [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none"
/>

<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>+
</button>
</div>

</div>    <div>
<label  > Aluminium (Al) </label>

<div className="flex items-center gap-1" style={{justifyContent:"center"}}>
<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>
&minus;
</button>

<input
type="number"
id="Quantity"
defaultValue={1}
className="h-10 w-16 rounded border-gray-200 text-center [-moz-appearance:_textfield] sm:text-sm [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none"
/>

<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>+
</button>
</div>

</div>
</div>
<div className="grid grid-cols-1 gap-4 text-center sm:grid-cols-3">
<div>
<label > Lithium (Li) </label>

<div className="flex items-center gap-1" style={{justifyContent:"center"}}>
<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>
&minus;
</button>

<input
type="number"
id="Quantity"
defaultValue={1}

className="h-10 w-16 rounded border-gray-200 text-center [-moz-appearance:_textfield] sm:text-sm [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none"
/>

<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>+
</button>
</div>

</div>
<div>
<label  > Oxygen (O) </label>

<div className="flex items-center gap-1" style={{justifyContent:"center"}}>
<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>
&minus;
</button>

<input
type="number"
id="Quantity"
defaultValue={1}
className="h-10 w-16 rounded border-gray-200 text-center [-moz-appearance:_textfield] sm:text-sm [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none"
/>

<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>+
</button>
</div>

</div>    <div>
<label  > Aluminium (Al) </label>

<div className="flex items-center gap-1" style={{justifyContent:"center"}}>
<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>
&minus;
</button>

<input
type="number"
id="Quantity"
defaultValue={1}
className="h-10 w-16 rounded border-gray-200 text-center [-moz-appearance:_textfield] sm:text-sm [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none"
/>

<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>+
</button>
</div>

</div>
</div>
<div className="grid grid-cols-1 gap-4 text-center sm:grid-cols-3">
<div>
<label > Lithium (Li) </label>

<div className="flex items-center gap-1" style={{justifyContent:"center"}}>
<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>
&minus;
</button>

<input
type="number"
id="Quantity"
defaultValue={1}

className="h-10 w-16 rounded border-gray-200 text-center [-moz-appearance:_textfield] sm:text-sm [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none"
/>

<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>+
</button>
</div>

</div>
<div>
<label  > Oxygen (O) </label>

<div className="flex items-center gap-1" style={{justifyContent:"center"}}>
<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>
&minus;
</button>

<input
type="number"
id="Quantity"
defaultValue={1}
className="h-10 w-16 rounded border-gray-200 text-center [-moz-appearance:_textfield] sm:text-sm [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none"
/>

<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>+
</button>
</div>

</div>    <div>
<label  > Aluminium (Al) </label>

<div className="flex items-center gap-1" style={{justifyContent:"center"}}>
<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>
&minus;
</button>

<input
type="number"
id="Quantity"
defaultValue={1}
className="h-10 w-16 rounded border-gray-200 text-center [-moz-appearance:_textfield] sm:text-sm [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none"
/>

<button
type="button"
className="w-10 h-10 leading-10 text-gray-600 transition hover:opacity-75"
>+
</button>
</div>

</div>
</div>


</form>
		</section>
	);
};
